import * as React from "react";
import { IOnderhoudPageProps } from "./IOnderhoudPageProps";
import { onderhoudBasePage } from "./onderhoudBasePage";

export function OnderhoudPageEn(props: IOnderhoudPageProps) {
  const pageMessage =
    "Due to maintenance, you cannot temporarily contact us via a web form. We apologize for the inconvenience.";
  return onderhoudBasePage("CAK - Maintenance", "In maintenance", pageMessage);
}
